import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import Page from 'sp-components/components/Page';

import Features from './Features';
import PrintTypes from './PrintTypes';
import Technology from './Technology';
import NationalProduction from './NationalProduction';

import './styles';

class HomePage2 extends Page {
  static propTypes = {
  }

  state = {}

  render() {
    return (
      <div className="HomePage2">
        <Helmet
          title="T-Shirt Printing & Fulfillment | DTG, Sublimation & Screen Printing"
          meta={[
            {
              name: 'description',
              content: 'Scalable Press is using technology to reinvent the mass customization industry. Through automation, we make it easier and faster to order customized goods.',
            },
          ]}
        />
        <Features />
        <PrintTypes />
        {/*<NationalProduction />*/}
        <Technology />
      </div>
    );
  }
}

function select(state) {
  return {
    user: state.auth.user,
  };
}

export default connect(select)(HomePage2);



// WEBPACK FOOTER //
// ./app/pages/HomePage2/index.jsx